<div *ngIf="!PageView;else other_content">
    <!-- <app-header-pre-login></app-header-pre-login> -->
    <!-- <img *ngIf="!IsMobile" src="../../assets/images/IIFL_New_Icons/IIFL_LoginBanner.svg" alt="" class="w-100 img-fluid">
    <img *ngIf="IsMobile" src="../../assets/images/IIFL_New_Icons/IIFL_Mob_Banner.svg" alt="" class="w-100 img-fluid"> -->
    <div class="LoginOuter {{CompanyName}}_LoginBg">
        <div class="MainOuter ">
            <div class="IIFLLoginImageContainer">
                <!-- <img src="../../assets/images/IIFL_New_Icons/IIFL_LoginIMG.svg" alt=""
                    class="w-100 img-fluid IIFLLoginImage"> -->
                <div class="IIFLLoginText">
                    <div class="NavigatingTitle">Navigating Your Investment Journey</div>
                    <!-- <div class="NavigatingParagraph">Lorem Ipsum has been the industry's standard dummy text ever since <br>the 1500s, when an unknown printer</div> -->
                </div>
            </div>
            <div class="card tab-card">
                <!-- <div class="UnderLineTabs">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link " id="one-tab" data-toggle="tab" href="#one" role="tab"
                            aria-controls="One" aria-selected="true">Mobile</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link " id="two-tab" data-toggle="tab" href="#two" role="tab" aria-controls="Two"
                            aria-selected="false">Email</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link active" id="three-tab" data-toggle="tab" href="#three" role="tab"
                            aria-controls="Three" aria-selected="false">SubBroker Code</a>
                    </li>
                </ul>
            </div> -->
                <div class="tab-content" id="myTabContent">
                    <!-- <div class="tab-pane fade px-4 pt-5 " id="one" role="tabpanel" aria-labelledby="one-tab">
                    <div class="row">
                        <div class="col-md-12 mx-auto">
                            <div class="step-opne">
                                <form autocomplete="off" [formGroup]="MobileLoginForm">
                                    <div class="row">
                                        <div class="col InputBoxOuter">
                                            <div class="has-float-label">
                                                <input type="text" id="Mobile" formControlName="Mobile" autofocus
                                                    class="form-control CommonTextBox" placeholder="&nbsp;"
                                                    [ngClass]="{ 'is-invalid': isMobileLoginFormSubbmitted && j.Mobile.errors }"
                                                    maxlength="10" (change)="SendOtpToMobile()"
                                                    (keypress)="isNumber($event)" />
                                                <label for="Mobile" class="lable">Mobile Number<span class="ColorRed">
                                                        *</span></label>
                                                <div *ngIf="isMobileLoginFormSubbmitted && j.Mobile.errors"
                                                    class="invalid-feedback">
                                                    <div *ngIf="j.Mobile.errors.required">Please enter mobile number
                                                    </div>
                                                    <div *ngIf="j.Mobile.errors.pattern">Enter Valid mobile number.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col InputBoxOuter">
                                            <div class="has-float-label">
                                                <input type="text" id="MobileOTP" formControlName="MobileOTP"
                                                    (keypress)="isNumber($event)" class="form-control CommonTextBox"
                                                    maxlength="6" placeholder="&nbsp;"
                                                    [ngClass]="{ 'is-invalid': isMobileLoginFormSubbmitted && j.MobileOTP.errors }" />
                                                <label for="MobileOTP" class="lable">Enter OTP<span class="ColorRed">
                                                        *</span></label>
                                                <div *ngIf="isMobileLoginFormSubbmitted && j.MobileOTP.errors"
                                                    class="invalid-feedback">
                                                    <div *ngIf="j.MobileOTP.errors.required">Please enter OTP</div>
                                                    <div *ngIf="j.MobileOTP.errors.pattern">Enter 6 Digit OTP Number
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <span routerLinkActive="active" class="ForgetPassLink"
                                                    (click)="OnClickReSendButton()">
                                                    Resend OTP
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="text-center SubmitMarginTop mb-4">
                                        <button class="CommonSubmitButton"
                                            [disabled]='j.Mobile.value == "" || j.MobileOTP.value == ""'
                                            (click)="OnMobileLogin()">Login</button>
                                    </div>
                                </form>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab-pane fade px-4 pt-5" id="two" role="tabpanel" aria-labelledby="two-tab">
                    <div class="row">
                        <div class="col-md-12 mx-auto">
                            <div class="step-opne">
                                <form autocomplete="off" [formGroup]="EmailLoginForm">
                                    <div class="row">
                                        <div class="col InputBoxOuter">
                                            <div class="has-float-label">
                                                <input type="text" id="Email" formControlName="Email" autofocus
                                                    class="form-control CommonTextBox"
                                                    [ngClass]="{ 'is-invalid': isEmailFormSubbmitted && e.Email.errors }"
                                                    placeholder="&nbsp;" (change)="SendOtpToEmail()" />
                                                <label for="Email" class="lable">Enter Email<span class="ColorRed">
                                                        *</span></label>
                                                <div *ngIf="isEmailFormSubbmitted && e.Email.errors"
                                                    class="invalid-feedback">
                                                    <div *ngIf="e.Email.errors.required">Please enter Email</div>
                                                    <div *ngIf="e.Email.errors.pattern">Enter valid email ID</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col InputBoxOuter">
                                            <div class="has-float-label">
                                                <input type="text" id="EmailOTP" formControlName="EmailOTP"
                                                    (keypress)="isNumber($event)" class="form-control CommonTextBox"
                                                    maxlength="6" placeholder="&nbsp;"
                                                    [ngClass]="{ 'is-invalid': isEmailFormSubbmitted && e.EmailOTP.errors }" />
                                                <label for="EmailOTP" class="lable">Enter OTP<span class="ColorRed">
                                                        *</span></label>
                                                <div *ngIf="isEmailFormSubbmitted && e.EmailOTP.errors"
                                                    class="invalid-feedback">
                                                    <div *ngIf="e.EmailOTP.errors.required">please enter otp</div>
                                                    <div *ngIf="e.EmailOTP.errors.pattern">Enter 6 digit OTP number
                                                    </div>
                                                </div>
                                            </div>
                                            <span routerLinkActive="active" class="ForgetPassLink"
                                                (click)="onClickReSendEmailOTP()">
                                                Resend OTP
                                            </span>
                                        </div>
                                    </div>
                                    <div class="text-center SubmitMarginTop mb-4">
                                        <button class="CommonSubmitButton"
                                            [disabled]='e.Email.value == "" || e.EmailOTP.value == ""'
                                            (click)="onEmailLoginClick()">Login</button>
                                    </div>
                                </form>

                            </div>
                        </div>
                    </div>
                </div> -->
                    <div class="tab-pane fade  show active" id="three" role="tabpanel" aria-labelledby="two-tab">
                        <div class="row">
                            <div class="col-md-12 mx-auto">
                                <div class="step-opne">
                                    <form autocomplete="off" [formGroup]="LoginForm" (ngSubmit)="onSubmit()"
                                        class="LoginForm">

                                        <div class="LoginFormDefultBox UserInputContainer ">
                                            <!--User Id LoginFormTitle start -->
                                            <div class="LoginFormTitle">Login to Incred Markets</div>
                                            <!--User Id LoginFormTitle end -->
                                            <!-- User Id input box start -->
                                            <div class="UserInputContainer d-none">
                                                <label for="Username" class="lable">
                                                    User ID
                                                </label>
                                                <input id="Username" type="text" formControlName="Username"
                                                    oninput="this.value = this.value.toUpperCase()" autofocus
                                                    class="form-control LoginFormInputTextBox"
                                                    [ngClass]="{ 'is-invalid': LoginSubmitted && r.Username.errors }"
                                                    placeholder="&nbsp;" maxlength="25" />

                                                <div *ngIf="LoginSubmitted && r.Username.errors"
                                                    class="invalid-feedback">
                                                    <div *ngIf="r.Username.errors.required">Please enter your User ID.
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- user Id input box end -->
                                            <!-- Enter Password input box start -->
                                            <div class="row mt-4 d-none">
                                                <div class="col InputBoxOuter">
                                                    <div class="UserInputContainer">
                                                        <label for="Password" class="lable">
                                                            Enter password
                                                        </label>
                                                        <show-hide-password btnStyle="" id="PasswordField"
                                                            [btnOutline]="false" class="Pass">
                                                            <input id="Password" type="password"
                                                                formControlName="Password"
                                                                class="form-control LoginFormInputTextBox"
                                                                [ngClass]="{ 'is-invalid': LoginSubmitted && r.Password.errors }"
                                                                placeholder="&nbsp;" maxlength="20" />
                                                            <div *ngIf="LoginSubmitted && r.Password.errors"
                                                                class="invalid-feedback">
                                                                <div *ngIf="r.Password.errors.required">Please enter
                                                                    your
                                                                    password.
                                                                </div>
                                                                <div *ngIf="r.Password.errors.pattern">Password contains
                                                                    atleast 1
                                                                    numeric , 1 uppercase, 1 lowercase and 1 special
                                                                    character
                                                                </div>
                                                                <!--Password contains atleast 1 number, 1 uppercase, 1 lowercase and 1 special charactor (@$!%*?&#)-->
                                                            </div>
                                                        </show-hide-password>
                                                    </div>
                                                    <span routerLink="/cp-forgot-password" routerLinkActive="active"
                                                        class="ForgetPassLink" (click)="SendUserType()">
                                                        Forgot Password?
                                                    </span>
                                                </div>
                                            </div>

                                            <!-- Enter Password input box end -->
                                            <!-- Login button start-->
                                            <!-- <button class="CommonSubmitButton" (click)="RedirectionMethod()">Login</button> -->
                                             <!-- <p class="redirecttxt">We are redirecting you to the AAA platform.please <a (click)="RedirectionMethod()" style="font-weight: bold;cursor: pointer;color: blue;">click here</a> to proceed. </p> -->
                                            <!-- Login button end-->
                                        </div>
                                        <!--  Pending  -->
                                        <div class="OtpVerificationBox d-none">
                                            <!-- OtpVerificationTitle start -->
                                            <div class=" ">
                                                <div class="OtpVerificationTopGrid">
                                                    <div class="TopLeftArrowImg">
                                                        <img src="../../assets/images/IIFL_New_Icons/TopLeftArrow.svg"
                                                            alt="">
                                                    </div>
                                                    <div class="OtpVerificationTitle">
                                                        OTP Verification
                                                    </div>
                                                </div>
                                                <p class="OtpVerificationParagraph">Please enter the OTP sent to your
                                                    registered <br> Mobile Number <span>*****3098</span> </p>
                                            </div>
                                            <!-- OtpVerificationTitle end -->
                                            <div class="row ">
                                                <div class="col InputBoxOuter">
                                                    <div class=" UserInputContainer">
                                                        <!-- OTP Verification input box start -->
                                                        <div class="">
                                                            <label for="Otp" class="lable OtpText">
                                                                Enter 6 digit OTP
                                                            </label>
                                                            <ng-otp-input id="OTPBox" #ngOtpInput [config]="{
                                                    length: 6,
                                                    inputClass: 'OTPBox',
                                                    allowNumbersOnly: true,
                                                    disableAutoFocus: false,
                                                    inputStyles: {
                                                    'text-security': 'disc',
                                                    '-webkit-text-security': 'disc',
                                                    '-moz-text-security': 'disc'
                                                    },
                                                    isNumberInput: true
                                                }" inputmode="numeric" pattern="[0-9]*">
                                                            </ng-otp-input>
                                                            <div class="ResendText">
                                                                <span class="ResendLink"> Resent OTP in
                                                                    <span id="timer">15 sec</span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <!-- OTP Verification input box end -->
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Generate OTP button start-->
                                            <button class="CommonSubmitButton  d-none">Generate OTP</button>
                                            <!-- Generate OTP button end-->
                                            <!-- Verify OTP button start-->
                                            <button class="CommonSubmitButton">Verify</button>
                                            <!-- Verify OTP button end-->
                                        </div>

                                        <div class="SetNewPasswordBox d-none">
                                            <!-- SetNewPasswordtitle start -->
                                            <div class="">
                                                <div class="OtpVerificationTopGrid">
                                                    <div class="TopLeftArrowImg">
                                                        <img src="../../assets/images/IIFL_New_Icons/TopLeftArrow.svg"
                                                            alt="">
                                                    </div>
                                                    <div class="OtpVerificationTitle SetNewPasswordtitle">
                                                        Set New Password
                                                    </div>
                                                </div>
                                                <p class="OtpVerificationParagraph SetNewPasswordParagraph">Please enter
                                                    a new password </p>
                                            </div>
                                            <!-- SetNewPasswordtitle end -->
                                            <div class="row ">
                                                <div class="col InputBoxOuter">
                                                    <div class=" UserInputContainer">
                                                        <!-- NewPassword input box start -->
                                                        <div class="">
                                                            <div class="NewPasswordBox">
                                                                <label for="NewPassword" class="lable">
                                                                    New Password
                                                                </label>
                                                                <show-hide-password btnStyle="" [btnOutline]="false"
                                                                    class="">
                                                                    <input id="NewPassword" type="text"
                                                                        formControlName="NewPassword" autofocus
                                                                        class="form-control LoginFormInputTextBox"
                                                                        placeholder="&nbsp;" maxlength="20" />
                                                                </show-hide-password>

                                                                <div class="PasswordValidationsBox">
                                                                    <div class="FirstValidation PasswordValidation">
                                                                        <div class="FirstValidationImg">
                                                                            <img src="../../assets/images/IIFL_New_Icons/PasswordValidationIcon1.svg"
                                                                                alt="">
                                                                        </div>
                                                                        <div class="FirstValidationText">8 - 12
                                                                            Characters</div>
                                                                    </div>
                                                                    <div class="SecondValidation PasswordValidation ">
                                                                        <div class="FirstValidationImg">
                                                                            <img src="../../assets/images/IIFL_New_Icons/PasswordValidationIcon1.svg"
                                                                                alt="">
                                                                        </div>
                                                                        <div class="FirstValidationText">Atleast 1
                                                                            Number</div>
                                                                    </div>
                                                                    <div class="ThirdValidation PasswordValidation ">
                                                                        <div class="FirstValidationImg">
                                                                            <img src="../../assets/images/IIFL_New_Icons/PasswordValidationIcon1.svg"
                                                                                alt="">
                                                                        </div>
                                                                        <div class="FirstValidationText">Do not have
                                                                            space & dots</div>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                            <div class="ConfirmPasswordBox ">
                                                                <label for="ConfirmPassword" class="lable">
                                                                    Confirm Password
                                                                </label>
                                                                <show-hide-password btnStyle="" [btnOutline]="false"
                                                                    class="">
                                                                    <input id="NewPassword" type="text"
                                                                        formControlName="NewPassword" autofocus
                                                                        class="form-control LoginFormInputTextBox"
                                                                        placeholder="&nbsp;" maxlength="25" />
                                                                </show-hide-password>

                                                                <div class="UnMatch_Validation">Password does not match
                                                                </div>
                                                                <div class="Match_Validation">
                                                                    <img src="../../assets/images/IIFL_New_Icons/GreenValidationIcon.svg"
                                                                        alt="">Password match
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <!-- NewPassword input box end -->
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- New Password button start-->
                                            <div class="text-center">
                                                <button class="CommonSubmitButton ">New Password</button>
                                            </div>
                                            <!-- New Password button end-->

                                        </div>

                                        <div class="ResetPasswordBox d-none">
                                            <!-- ResetPasswordtitle start -->
                                            <div class="">
                                                <div class="OtpVerificationTopGrid">
                                                    <div class="TopLeftArrowImg">
                                                        <img src="../../assets/images/IIFL_New_Icons/TopLeftArrow.svg"
                                                            alt="">
                                                    </div>
                                                    <div class="OtpVerificationTitle SetNewPasswordtitle">
                                                        Reset Password
                                                    </div>
                                                </div>
                                                <p class="OtpVerificationParagraph SetNewPasswordParagraph">Please enter
                                                    a new password </p>
                                            </div>
                                            <!-- ResetPasswordtitle end -->
                                            <div class="row ">
                                                <div class="col InputBoxOuter">
                                                    <div class=" UserInputContainer">
                                                        <!-- ResetPassword input box start -->
                                                        <div class="">
                                                            <div class="NewPasswordBox">
                                                                <label for="NewPassword" class="lable">
                                                                    Reset Password
                                                                </label>
                                                                <show-hide-password btnStyle="" [btnOutline]="false"
                                                                    class="">
                                                                    <input id="NewPassword" type="text"
                                                                        formControlName="NewPassword" autofocus
                                                                        class="form-control LoginFormInputTextBox"
                                                                        placeholder="&nbsp;" maxlength="25" />
                                                                </show-hide-password>

                                                                <div class="PasswordValidationsBox">
                                                                    <div class="FirstValidation PasswordValidation">
                                                                        <div class="FirstValidationImg">
                                                                            <img src="../../assets/images/IIFL_New_Icons/PasswordValidationIcon1.svg"
                                                                                alt="">
                                                                        </div>
                                                                        <div class="FirstValidationText">8 - 12
                                                                            Characters</div>
                                                                    </div>
                                                                    <div class="SecondValidation PasswordValidation ">
                                                                        <div class="FirstValidationImg">
                                                                            <img src="../../assets/images/IIFL_New_Icons/PasswordValidationIcon1.svg"
                                                                                alt="">
                                                                        </div>
                                                                        <div class="FirstValidationText">Atleast 1
                                                                            Number</div>
                                                                    </div>
                                                                    <div class="ThirdValidation PasswordValidation ">
                                                                        <div class="FirstValidationImg">
                                                                            <img src="../../assets/images/IIFL_New_Icons/PasswordValidationIcon1.svg"
                                                                                alt="">
                                                                        </div>
                                                                        <div class="FirstValidationText">Do not have
                                                                            space & dots</div>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                            <div class="ConfirmPasswordBox ">
                                                                <label for="ConfirmPassword" class="lable">
                                                                    Confirm Password
                                                                </label>
                                                                <show-hide-password btnStyle="" [btnOutline]="false"
                                                                    class="">
                                                                    <input id="NewPassword" type="text"
                                                                        formControlName="NewPassword" autofocus
                                                                        class="form-control LoginFormInputTextBox"
                                                                        placeholder="&nbsp;" maxlength="25" />
                                                                </show-hide-password>

                                                                <div class="UnMatch_Validation">Password does not match
                                                                </div>
                                                                <div class="Match_Validation">
                                                                    <img src="../../assets/images/IIFL_New_Icons/GreenValidationIcon.svg"
                                                                        alt="">Password match
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <!-- ResetPassword input box end -->
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Reset Password button start-->
                                            <div class="text-center w-100">
                                                <button class="CommonSubmitButton ">Reset Password</button>
                                            </div>
                                            <!-- Reset Password button end-->
                                        </div>

                                        <div class="PasswordSetSuccessfullyGreetingBox d-none">
                                            <div class="row ">
                                                <div class="col InputBoxOuter">

                                                    <div class=" UserInputContainer">
                                                        <!-- PasswordSetSuccessfully Greeting box start -->
                                                        <div class="">
                                                            <div class="GreetingBox">

                                                                <div class="GreetingImg">
                                                                    <img src="../../assets/images/IIFL_New_Icons/PasswordSetSuccessIcon.svg"
                                                                        alt="">
                                                                </div>

                                                                <div class="GreetingText">
                                                                    Your password <br> has been set successfully!
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <!-- PasswordSetSuccessfully Greeting box end -->
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- PasswordSetSuccessfully Greeting Login button start-->
                                            <div class="text-center w-100 mb-5">
                                                <button
                                                    class="CommonSubmitButton PasswordSetSuccessGreetingBtn ">Login</button>
                                            </div>
                                            <!-- PasswordSetSuccessfully Greeting Login button end-->
                                        </div>


                                        <!-- <div class="">
                                         <div class="WhoIAmOuter mb-3">
                                                <div *ngIf="IsShowLoginOption" class="col-12 p-0">
                                                    <div class="WhoIAMLink">
                                                        I am <a (click)="ChangeType()">
                                                            <span *ngIf="!IsInvestor">an <span class="BlueText">Investor</span></span>
                                                            <span *ngIf="IsInvestor">a <span class="BlueText">Distributor</span></span>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>       
                                    </div>-->

                                    </form>
                                    <!-- <div class="text-center CreateAccount ">
                                    <div *ngIf='UserType == 2'>
                                        Don't have a distributor account?
                                        <span class="BlueText" routerLink="/referral-onboarding"
                                            routerLinkActive="active">Create Account</span>
                                    </div>
                                </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="LoginPageFooter fixed-bottom">
        <div class="FooterText mb-1">Copyright &#169; 2024 <span class="FooterBlueText CursorPointer">Incred Markets Limited</span> All rights Reserved.</div>
        <div class="FooterText">SEBI REGN NO.:INZ000164132, DEPOSITORY: IN DP NSDL 185 2000, IN DP CDSL 352 2006 | AMFI REGN NO.: ARN-47791, India Infoline Commodities Limited: NCDEX: NCDEX-CO-04-00378 & MCX:10470</div>
    </div> -->
        <!-- <div *ngIf="!IsMobile" class="LoginPageFooter fixed-bottom">
            <div class="FooterText mb-1"><span class="FooterBlueText CursorPointer">Incred Markets</span> SEBI
                REGN. NO. : INZ000164132 | ARN NO (AMFI Registered Mutual Fund Distributor): 47791 </div>
            <div class="FooterText">(Date of initial Registration as : 17/02/2007; Current ARN Validity up to:
                08/02/2027) | BSE MFD: 10234|RA NO: INH000000248 | IA NO: INA000000623 | Depository Participation: NSDL
                & CDSL: INDP185 2016</div>
        </div>
        <div *ngIf="IsMobile" class="LoginPageFooter fixed-bottom">
            <div class="FooterText"><span class="FooterBlueText CursorPointer">Incred Markets</span> SEBI REGN.
                NO. : INZ000164132 | ARN NO (AMFI Registered Mutual Fund Distributor): 47791 (Date of initial
                Registration as : 17/02/2007; Current ARN Validity up to: 08/02/2027) | BSE MFD: 10234|RA NO:
                INH000000248 | IA NO: INA000000623 | Depository Participation: NSDL & CDSL: INDP185 2016
            </div>
        </div> -->
    </div>
    <!-- The Modal End -->
    <div class="modal" id="AlertModalLogin" appDisabledRightClick>
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content AlertModalContentCls">
                <div class="modal-header AlertModalHeader">Select Client</div>
                <div id="AlertModalContentv" class="modal-body AlertModalBody">

                    <div class="tab-content TabContentData px-0">
                        <div id="Clients" class="tab-pane fade show active">
                            <div class="TableDataMainData MainDataLRPadding pt-15">
                                <div class="table-responsive">
                                    <table id="ClientsTable" class="CommonTable ClientsTable"
                                        *ngIf="isMobileListDisplay">
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Mobile Number</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let client of ClientData">
                                                <td>{{client.FirstName}}</td>
                                                <td>{{client.MobileNo}}</td>
                                                <td>
                                                    <button class="BtnCommon"
                                                        style="background-color: var(--primary-color);"
                                                        (click)="OnClickClientSelection(client)">Login</button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="modal-footer AlertModalFooter">

                </div>
            </div>
        </div>
    </div>

    <div class="modal" id="AlertModalLoginEmail" appDisabledRightClick>
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content AlertModalContentCls">
                <div class="modal-header AlertModalHeader">Select Client</div>
                <div id="AlertModalContentv5" class="modal-body AlertModalBody">
                    <div class="tab-content TabContentData px-0">
                        <div id="Clients" class="tab-pane fade show active">
                            <div class="TableDataMainData MainDataLRPadding pt-15">
                                <div class="table-responsive">
                                    <table id="ClientsTable" class="CommonTable ClientsTable"
                                        *ngIf="isEmailListDisplay">
                                        <thead>
                                            <tr>
                                                <th>Name.</th>
                                                <!-- <th>PAN Number</th> -->
                                                <th>Email Id</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let client of ClientDataBasedOnEmail">
                                                <td>{{client.FirstName}}</td>
                                                <!-- <td>{{client.PANNo}}</td> -->
                                                <td>{{client.EmailId}}</td>
                                                <td>
                                                    <button class="BtnCommon"
                                                        style="background-color: var(--primary-color);"
                                                        (click)="BasedonEmailSelection(client)">Login</button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="modal-footer AlertModalFooter">

                </div>
            </div>
        </div>
    </div>

    <app-footer></app-footer>
</div>
<ng-template #other_content></ng-template>